const HEADERS = [
  'ID',
  'デバイス',
  'キャンペーン',
  '開始日時',
  '終了日時',
  '配信数',
  'コンバージョン率',
  '経由売上',
  '平均単価',
  'カートボタンクリック率',
  'コンバージョン上昇率',
  '平均単価上昇率',
  '非表示率',
];

const FIELDS = [
  'id',
  'device',
  'name',
  'start_at',
  'end_at',
  'delivery_count',
  'conversion_rate',
  'conversion_price',
  'average_conversion_price',
  'cart_button_click_rate',
  'conversion_up_rate',
  'conversion_price_up_rate',
  'control_percent',
];

const FORMAT = 'YYYYMM';

angular.module('zc')
  .component('zcSiteReportCampaignTable', {
    templateUrl: '/templates/projects.site_reports/campaign_table.html',
    bindings: { project: '<' },
    controller: zcSiteReportCampaignTableController,
  });

zcSiteReportCampaignTableController.$inject = ['$scope', 'ChartV2', 'funnelChartV2Config'];
function zcSiteReportCampaignTableController($scope, ChartV2, currencies, funnelChartV2Config) {
  const vm = this;

  $scope.currency = currencies[$scope.currentProject.currency];
  $scope.currencyStep = 1 / 10 ** $scope.currency.fractionSize;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.campaigns) return;
    vm.getCSV = getCSV;
    vm.filename = getFilename();
    vm.project.campaigns.forEach(campaign => {
      campaign.banner = campaign.element.message.banner;
      setChartConfig(campaign);
    });
  });

  function setChartConfig(campaign) {
    const data = _.sortBy([
      // NOTE: Rooting values in order to balance each data in view
      ['配信', Math.sqrt(campaign.session_count)],
      ['カートボタンクリック', Math.sqrt(campaign.cart_button_click_count)],
      ['コンバージョン', Math.sqrt(campaign.conversion_count)],
    ], i => -i[1]);
    const chart = new ChartV2(funnelChartV2Config);
    campaign.chartConfig = chart.getConfig();
    chart.addSeries({ name: '訪問数', data });
  }

  function getFilename() {
    const yearMonth = moment(vm.project.thisMonthStat.start_at).format(FORMAT);
    return `campaigns-table-${vm.project.apikey}-${yearMonth}.csv`;
  }

  function getCSV() {
    if(!vm.project.campaigns) return;
    const result = [];
    result.push(HEADERS);
    vm.project.campaigns.forEach(campaign => {
      const row = FIELDS.map(field => _.get(campaign, field));
      result.push(row);
    });
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.site_reports/campaign_table.controller.js